import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginApiRequest } from "../authConfig";
import Button from "react-bootstrap/Button";


/**
 * Renders a button which, when selected, will open a popup for login
 */
export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginApiRequest).catch(e => {
                console.log(e);
            });
        }
        if (loginType === "redirect") {
            instance.loginRedirect(loginApiRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <Button variant="secondary" className="ml-auto" onClick={() => handleLogin("redirect")}>Zaloguj</Button>
    );
}